module.exports = __webpack_public_path__ + "img/icon-32-ic-hourglass.47196d9d.svg";